import React from 'react';
import SEOHead from '@/components/SEOHead';
import { ThemeProvider } from '@/components/ThemeProvider';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

/**
 * Privacy Policy page component
 * Provides comprehensive privacy policy information for the website
 * Includes data collection, usage, and protection details
 */
const PrivacyPolicy = () => {
  return (
    <>
      <SEOHead 
        title="Privacy Policy - Matthew Innes Portfolio"
        description="Privacy policy for Matthew Innes portfolio website. Learn how we collect, use, and protect your personal information."
        canonical="https://matthewweb.com/privacy-policy"
      />
      <ThemeProvider>
        <div className="min-h-screen flex flex-col bg-background text-foreground dark:bg-navy dark:text-lightSlate">
          <Navbar />
          <main className="flex-grow container mx-auto px-4 py-16 max-w-4xl">
            <div className="prose prose-lg max-w-none dark:prose-invert">
              <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
              <p className="text-lg text-muted-foreground mb-8">
                Last updated: {new Date().toLocaleDateString('en-GB')}
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">1. Information We Collect</h2>
                <p className="mb-4">
                  We collect information you provide directly to us, such as when you contact us through our contact form.
                </p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Name and email address (when you contact us)</li>
                  <li>Any messages or information you voluntarily provide</li>
                  <li>Technical information such as IP address and browser type</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">2. How We Use Your Information</h2>
                <p className="mb-4">We use the information we collect to:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Respond to your enquiries and provide customer support</li>
                  <li>Improve our website and services</li>
                  <li>Communicate with you about our services</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">3. Information Sharing</h2>
                <p className="mb-4">
                  We do not sell, trade, or otherwise transfer your personal information to third parties without your consent,
                  except as described in this privacy policy.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">4. Data Security</h2>
                <p className="mb-4">
                  We implement appropriate security measures to protect your personal information against unauthorised access,
                  alteration, disclosure, or destruction.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">5. Contact Information</h2>
                <p className="mb-4">
                  If you have any questions about this privacy policy, please contact us through our contact form.
                </p>
              </section>
            </div>
          </main>
          <Footer />
        </div>
      </ThemeProvider>
    </>
  );
};

export default PrivacyPolicy;
